import styled from "styled-components";
import { DefaultInput } from "@alboompro/boom-components/data-entry/input/Input";

export const BetaLabel = styled.div`
  position: absolute;
  top: -7px;
  border-radius: 30px;
  padding: 2px 8px;
  background-color: #dc624b;
  color: #ffffff;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 9px;
  line-height: 10px;
  letter-spacing: 0.4px;
`;

export const SearchInput = styled(DefaultInput)`
  padding: 15px;
  margin: 0;
  img {
    margin-right: 4px;
  }
  input {
    padding: 10px 28px 10px 12px;
    font-size: 12px;
    border: 1px solid #EBEBEB;
    color: #3e3e3e;
    border-radius: 3px;

    ::-webkit-input-placeholder{ 
      color: #A4A4A4;
    }

    &:focus {
      box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
    }
  }
`;

export const PremiumLabel = styled.div`
  z-index: 2;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  border-radius: 10px;
  background-color: #efc066;
  transition: 0.8s;
  top: 5px;
  right: 5px;
  height: 20px;

  & > svg {
    width: 10px;
  }

  ${({ isPremium }) =>
    isPremium &&
    `
      cursor: pointer!important

      &:hover {
        > span {
          max-width: 200px;
        }
      }
  `}

  > span {
    display: flex;
    max-width: 0;
    overflow: hidden;
    font-size: 8px;
    color: #fff;
    letter-spacing: 1.6px;
    font-weight: 500;
    transition: 0.8s;

    &:after,
    &:before {
      content: "";
      display: block;
      min-width: 8px;
      height: 1px;
    }
  }
`;

export const NewLabel = styled.div`
  position: absolute;
  top: -7px;
  border-radius: 30px;
  padding: 2px 8px;
  background-color: #796dbb;
  color: #ffffff;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 9px;
  line-height: 10px;
  letter-spacing: 0.4px;
`;

export const ToolsTitle = styled.div`
  padding: 20px 0;
  text-align: center;
  color: #464646;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0;
`;

export const ToolsBarContainer = styled.div`
  display: flex;
  width: 230px;
  background-color: #f9f9f9;
  box-shadow: 1px 0px 4px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  max-height: 100%;
  overflow-y: auto;
  z-index: 1;

  > div {
    min-width: 100%;
  }

  .tool-group {
    &:last-child {
      ${ToolsTitle} {
        margin: 20px 0 5px 0;
      }
    }
  }
`;

export const ToolsContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 15px;
  justify-content: space-between;
`;

export const ComponentTitle = styled.div`
  font-size: 12px;
  line-height: 1.2;
  max-width: 90%;
  text-align: center;
  color: #545454;
  transition: 0.1s color;
`;

export const DisabledContainer = styled.div`
  background: #ffffff;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.18);
  border-radius: 3px;
  padding: 14px;
  width: 330px;
  display: none;
  opacity: 0;
  position: fixed;
  top: ${(props) => (props.position ? props.position.bottom + 5 : 0)}px;
  left: ${(props) => (props.position ? props.position.x : 0)}px;
  transition: 0.1s opacity ease-in-out;

  h4 {
    font-size: 13px;
    line-height: 16px;
    color: #282828;
    margin-bottom: 8px;
  }

  p {
    font-size: 12px;
    line-height: 14px;

    color: #4a4a4a;
  }
`;

export const ComponentItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 90px;
  margin-bottom: 15px;
  background-color: #fdfdfd;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  cursor: grab;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0);
  transition: 0.1s all;

  &:hover {
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);

    > ${ComponentTitle} {
      color: #44adf8;
    }
  }

  img {
    margin-bottom: 9px;
    pointer-events: none;
  }

  &.disabled,
  &.cerberus {
    cursor: initial;
    position: relative;
    user-select: none;
    border: 1px solid #e0e0e0;
    color: #545454;

    img {
      opacity: 0.5;
    }

    &:hover {
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0);

      > ${ComponentTitle} {
        color: #545454;
      }

      > ${DisabledContainer} {
        opacity: 1;
        display: block;
        z-index: 90;
      }
    }
  }

  &.cerberus {
    cursor: not-allowed;

    :hover {
      > ${PremiumLabel} {
        > span {
          max-width: 200px;
        }
      }
    }
  }

  ${({ newElement, beta }) => {
    if(newElement) {
      return "border-color: #796dbb;"
    } if(beta) {
      return "border-color: #dc624b;"
    }
    return null;
  }}
`;

export const ToolsIconsContainer = styled.div`
  transition: 0.3s;
  ${(prop) => (prop.elementSelected ? "margin-left: -230px;" : null)}
`;

export const IconWrapper = styled.img`
  max-width: 24px;
  max-height: 24px;
`;

export const NoResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  gap: 20px;

  text-align: center;
  color: #545454;
  line-height: 1.4em;
  font-size: 14px;
`;
